import { Box, useTheme } from '@mui/material';
import confetti from 'canvas-confetti';
import { Award } from '../Award/Award';
import { useUser } from '../../hooks/useUser/useUser';
import { Loading } from '../Loading/Loading';
import { awardMapper } from '../../helpers/awardMapper';
import { awardContainerSx, confettiOptions } from './Achievements.style';

export const Achievements = () => {
  const theme = useTheme();
  const { userData, isUserLoading } = useUser();
  const mappedAwards = awardMapper(theme, userData);
  const isAchievementsUnlocked = mappedAwards.some((a) => a.isActive);

  if (isAchievementsUnlocked) {
    confetti(confettiOptions);
  }

  return !isUserLoading ? (
    <Box sx={awardContainerSx(theme)}>
      {mappedAwards.map((a, i) => (
        <Award key={i} color={a.color} text={a.text} isActive={a.isActive} />
      ))}
    </Box>
  ) : (
    <Loading />
  );
};
